import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Grid,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import TwitterIcon from '@mui/icons-material/Twitter';
import XIcon from '@mui/icons-material/X';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import { useTheme } from '@mui/material/styles';
import { CYBER_CONFIG } from '../../constants/cyberConfig';
import { PAGES } from '../../constants';

interface ShareModalProps {
  open: boolean;
  onClose: () => void;
}

declare global {
  interface Window {
    FB?: any;
  }
}

export const ShareModal: React.FC<ShareModalProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const [title, setTitle] = useState('Chubb Cyber Index');
  const [subtitle, setSubtitle] = useState('');
  const [facebookAppId, setFacebookAppId] = useState('');

  const currentUrl = window.location.href;
  const shareUrl = 'https://chubbcyberindex.com';

  useEffect(() => {
    // Fetch content and config if needed
    // For now using defaults, you can integrate with your data retrieval service
    loadShareContent();
  }, []);

  const loadShareContent = async () => {
    try {
      // You can fetch from your config files here
      // const content = await fetch('/assets/chubb-ci-pages-content.json');
      // const config = await fetch('/assets/cyber-config.json');
      
      // For now using defaults
      setTitle(PAGES['incident-growth'].contents.title.text);
      setSubtitle(PAGES['incident-growth'].contents.sub.text);
      setFacebookAppId(CYBER_CONFIG.facebook.share.appId);
    } catch (error) {
      console.error('Error loading share content:', error);
    }
  };

  const handleLinkedInShare = () => {
    const linkedInUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
      shareUrl
    )}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(subtitle)}&source=CyberIndex`;
    
    window.open(linkedInUrl, '_blank');
  };

//   const handleTwitterShare = () => {
//     const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
//       title
//     )}&url=${encodeURIComponent(shareUrl)}&via=ChubbNA&hashtags=cyberindex,chubbcyberindex,chubb`;
    
//     window.open(twitterUrl, '_blank');
//   };
  const handleXShare = () => {
    // X.com (formerly Twitter) intent URL
    const xUrl = `https://x.com/intent/post?text=${encodeURIComponent(
      title
    )}&url=${encodeURIComponent(shareUrl)}`;
    
    window.open(xUrl, '_blank');
  };

  const handleEmailShare = () => {
    const emailSubject = encodeURIComponent(title);
    const emailBody = encodeURIComponent(
      `Chubb Cyber Index: ${shareUrl}\n\n${subtitle}`
    );
    const mailtoUrl = `mailto:?Subject=${emailSubject}&Body=${emailBody}`;
    
    window.location.href = mailtoUrl;
  };

  const handleFacebookShare = () => {
    if (window.FB) {
      window.FB.ui(
        {
          display: 'popup',
          method: 'share',
          href: shareUrl,
          ...(facebookAppId && { appId: facebookAppId }),
        },
        // (response: any) => {
        //   if (response && !response.error_message) {
        //   }
        // }
      );
    } else {
      // Fallback if FB SDK not loaded.
      const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
      window.open(facebookUrl, '_blank', 'width=600,height=600');
    }
  };

  const socialButtons = [
    {
      id: 'linkedin',
      icon: LinkedInIcon,
      color: '#0077B5',
      onClick: handleLinkedInShare,
      label: 'Share on LinkedIn',
    },
    // {
    //   id: 'twitter',
    //   icon: TwitterIcon,
    //   color: '#1DA1F2',
    //   onClick: handleTwitterShare,
    //   label: 'Share on Twitter',
    // },
    {
      id: 'x',
      icon: XIcon,
      color: '#000000',
      onClick: handleXShare,
      label: 'Share on X',
    },
    {
      id: 'email',
      icon: EmailIcon,
      color: '#EA4335',
      onClick: handleEmailShare,
      label: 'Share via Email',
    },
    {
      id: 'facebook',
      icon: FacebookIcon,
      color: '#1877F2',
      onClick: handleFacebookShare,
      label: 'Share on Facebook',
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
        }}
      >
        <Typography variant="h6" component="div">
          Share this insightful tool with your colleagues
        </Typography>
        <IconButton
          edge="end"
          onClick={onClose}
          aria-label="close"
          sx={{ ml: 2 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 3, pb: 4 }}>
        <Grid
          container
          spacing={3}
          justifyContent="center"
          alignItems="center"
        >
          {socialButtons.map((button) => {
            const IconComponent = button.icon;
            return (
              <Grid
                size= {{ xs: 12, sm: 6, md: 3 }}
                key={button.id}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <IconButton
                  onClick={button.onClick}
                  aria-label={button.label}
                  sx={{
                    width: 60,
                    height: 60,
                    backgroundColor: button.color,
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: button.color,
                      opacity: 0.8,
                    },
                  }}
                >
                  <IconComponent sx={{ fontSize: 32 }} />
                </IconButton>
              </Grid>
            );
          })}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};